<template>
  <div class="success-step">
    <Typography variant="h-1"> Success! </Typography>
    <Typography variant="h-5"> Your {{ type }} was {{ action }}! </Typography>
    <Robin :height="120" :width="140" class="" :loop="false" animation="backflip" />
    <Button @click="$emit('close')"> Close </Button>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import Robin from "@/components/Robin.vue";

export default {
  name: "SuccessStep",
  components: {
    Typography,
    Button,
    Robin,
  },
  props: {
    type: {
      type: String,
      default: "module",
    },
    action: {
      type: String,
      default: "published",
    },
  },
  emits: ["close"],
};
</script>

<style scoped>
.success-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
}
</style>
